<router-outlet></router-outlet>
<app-spinner
	[spinnerType]="5"
	[random]="true"
></app-spinner>